import { Box } from '@mui/material'
import React from 'react'
import LoadingSpinner from '../../Loading/LoadingSpinner'

const BodyContainer = ({ children, className = '', classNameWrapper = '', loading, px = '2', py = '2', style = {} }) => {
  return (
    <Box className={`px-${px} py-${py} h-screen-module-body-body flex items-start gap-2 ${className}`} style={style}>
      <div className={`relative w-full h-full ${classNameWrapper}`}>
        { loading && <LoadingSpinner /> }
        {children}
      </div>
    </Box>
  )
}

export default BodyContainer